import React from 'react';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import { useGetFirms } from '../../api/hooks/sales';
import { toPersianNumber } from '../../utils/helpers';
// import { Tooltip } from '@mui/material';

export default function FirmsTable({ subsidaries }) {
  const { data: firms } = useGetFirms(subsidaries);
  return (
    <Paper variant="outlined" sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {firms?.map((row) => {
              return (
                <TableRow hover tabIndex={-1} key={row.name}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

const columns = [
  { id: 'name', label: 'نام', minWidth: 120 },
  { id: 'nationalId', label: 'کد ملی', minWidth: 70, format: toPersianNumber },
  // { id: 'ecoId', label: 'کد اقتصادی', minWidth: 70, format: toPersianNumber },
  { id: 'postalCode', label: 'کد پستی', minWidth: 70, format: toPersianNumber },
  { id: 'phoneNumber', label: 'تلفن', minWidth: 70, format: toPersianNumber },
  {
    id: 'address',
    label: 'آدرس',
    minWidth: 170,
    // format: (address) => <Tooltip title={address}>{address}</Tooltip>,
  },
  { id: 'isSubsidary', label: 'نوع', minWidth: 50, format: (is) => (is ? 'داخلی' : 'مشتری') },
];
